// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../k8-opt-exec/bin/redo/shopify/extension/webpack.bin.runfiles/rules_javascript++yarn+redo_npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._1y-0 {\n  width: 0;\n  height: 0;\n  opacity: 0;\n  position: absolute;\n  overflow: hidden;\n  z-index: -1;\n}\n._1y-0 > * {\n    white-space: nowrap;\n    overflow: visible;\n  }\n", ""]);
// Exports
export var measureBox = "_1y-0";
export default ___CSS_LOADER_EXPORT___;
